import { styled } from "../../../../../../styles";

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  height: "589px",
  width: "833px",
  gap: "12px",

  "@media screen and (max-width: 1100px)": {
    width: "calc(100vw - 80px)",
    overflow: "scroll",
    height: "calc(100vh - 80px)",
  },
});

export const NotAvailableContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  width: "440px",
  gap: "12px",

  "@media screen and (max-width: 1100px)": {
    width: "calc(100vw - 80px)",
  },
});

export const NotAvailableMessage = styled("p", {
  fontSize: "$text-md",
  lineHeight: "20px",
  padding: "0 22px",
  color: "$gray-100",
});

export const Title = styled("h1", {
  fontWeight: 500,
  fontSize: "$text-xl",
  lineHeight: "22px",
  padding: "24px 22px 12px 22px",
  color: "$black",
});

export const SubmitContainer = styled("div", {
  display: "flex",
  gap: "40px",
  padding: "24px 22px 24px 22px",
  alignItems: "center",
});

export const EditButton = styled("button", {
  height: "$13",
  padding: "0 $13",
  marginLeft: "-38px",

  borderRadius: "20px",
  border: "2px solid $white",

  backgroundColor: "$white",

  gap: "$4",

  display: "flex",
  alignItems: "center",

  color: "$black",
  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  "&:focus": {
    outline: "none",
    border: "2px solid $primary-30",
  },

  "@sm": {
    width: "80px",
    height: "26px",
    fontSize: "12px",
    marginLeft: "40px",
    paddingLeft: "19px",
  },
});

export const Label = styled("p", {
  fontSize: "$text-md",
  paddingBottom: "0px",
  lineHeight: "16px",
  paddingLeft: 22,
  color: "$gray-100",
});

export const AssignedToLabel = styled("p", {
  fontSize: "$text-md",
  paddingBottom: "0px",
  lineHeight: "16px",
  paddingLeft: 22,
  color: "$gray-100",
});

export const UrgentChipContainer = styled("div", {
  paddingLeft: 22,
  display: "flex",
});

export const TextAreaContainer = styled("div", {
  paddingLeft: "22px",
  paddingRight: "22px",
  width: "100%",
  height: "370px",
});
